import { Outlet } from 'react-router-dom';
import SideMenu from './SideMenu';
import { useEffect, useState } from 'react';
import usePresetStore from 'store/presetStore';

function PageLayout() {
  const { fetchPresetValues } = usePresetStore();
  const [presetsLoaded, setPresetsLoaded] = useState<boolean>(false);
  useEffect(() => {
    (async () => {
      if (!presetsLoaded) {
        await fetchPresetValues();
        setPresetsLoaded(true);
      }
    })().catch((error) => {
      // Ignore error
      console.error('Preset load error', error);
    });
  }, [presetsLoaded, fetchPresetValues]);
  return (
    <div className="flex flex-row">
      <SideMenu className="flex-shrink-0" />
      <div className="w-full overflow-x-auto bg-white">
        <Outlet />
      </div>
    </div>
  );
}

export default PageLayout;
